function q(selectors, root) {
    return ((selectors && root !== null && (root || document).querySelector(selectors)) ||
        undefined);
}

module.exports = q;
